import { Typography } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import DpicFeed from "../../../../../components/commons/DpicFeed";
import styles from "../../../Profile.module.css";
import RatingFeed from "../../edit/components/RatingFeed";
import CustomerRateFeed from "./CustomerRateFeed";
import EditDescFeed from "./EditDescFeed";
import IconSectionView from "./IconSectionView";
import Languages from "./Languages";
import Tags from "./Tags";
import InstituteCode from "./InstituteCode";

class LeftSideBar extends React.Component {
  handleVisitBusiness = () => {
    window.open("https://scale.com/", "_blank");
  };

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
          }}
        >
          <DpicFeed props={this.props} editpage={false} />
        </div>

        <div
          style={{
            width: "100%",
          }}
        >
          <EditDescFeed editpage={this.props.props.editpage} />
          <br />
        </div>

        {this.props.userTypeView === "LOCAL BUSINESS" && (
          <div
            style={{
              width: "100%",
            }}
          >
            <InstituteCode
              profileId={this.props.props.match.params.id}
            />
            <br />
          </div>
        )}

        {this.props.userTypeView === "INDIVIDUAL" && (
          <div
            style={{
              width: "100%",
              cursor: "pointer",
            }}
            onClick={this.handleVisitBusiness}
          >
            <img
              src="/Image/DashImage/Business/Scale.jpg"
              alt="business"
              style={{ 
                width: "100%", 
                borderRadius: "15px 15px 0px 0px",
                transition: "opacity 0.3s ease",
              }}
              onMouseOver={(e) => e.target.style.opacity = "0.8"}
              onMouseOut={(e) => e.target.style.opacity = "1"}
            />
            <Typography
              sx={{
                textAlign: "center",
                color: "#fff",
                backgroundColor: "#F33070",
                borderRadius: "0px 0px 15px 15px",
                p: "5px ",
                transition: "background-color 0.3s ease",
                "&:hover": {
                  backgroundColor: "#d12759",
                },
              }}
            >
              Visit Business
            </Typography>
          </div>
        )}

        {this.props.userTypeView === "LOCAL BUSINESS" && (
          <>
            <div
              style={{
                width: "100%",
              }}
            >
              <RatingFeed editPage={false} />
              <br />
            </div>

            <div
              style={{
                width: "100%",
              }}
            >
              <CustomerRateFeed />
              <br />
            </div>
          </>
        )}

        <div
          style={{
            width: "100%",
          }}
        >
          <Tags editpage={this.props.props.editpage} />
          <br />
        </div>

        <div
          className={styles.icon_section_feed}
          style={{
            width: "100%",
          }}
        >
          <IconSectionView />
          <br />
        </div>

        {this.props.userTypeView === "INDIVIDUAL" && (
          <div
            style={{
              width: "100%",
            }}
          >
            <Languages />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //U can destructure here to get only the required attributes from the state
  return {
    userTypeView: state?.profile?.user_type_view,
  };
};

export default connect(mapStateToProps, null)(LeftSideBar);